<template>
  <button
    class="mdc-fab mdc-fab--extended button"
    :class="{ 'will-register': willRegister }"
    aria-label="Register"
    @click="$listeners.click"
  >
    <span class="mdc-fab__label">
      {{ _isEdit ? '予約更新' : '予約登録' }}
    </span>
    <md-icon class="mdc-fab__icon"
      ><font-awesome-icon
        class="icon"
        :icon="_isEdit ? 'calendar-check' : 'calendar-plus'"
    /></md-icon>
  </button>
</template>

<script>
export default {
  props: {
    willRegister: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _isEdit() {
      return this.isEdit
    },
  },
}
</script>

<style lang="scss" scoped>
$mdc-theme-secondary: #448aff;
@import '@material/fab/mdc-fab';
.button {
  background-color: #dfac40 !important;
}
.button.will-register:hover {
  .icon {
    animation: bounce 0.8s ease-out;
  }
}
.icon {
  color: #fff;
  margin-right: 8px;
}
</style>
